import * as React from "react";
import { inject, observer } from "mobx-react";
import ReactToPrint from "react-to-print";
import { Loader, ErrorMessage } from "components";

import {
  PaperworkEntryPrintTemplate,
} from "modules/paperwork-entry";


@inject(rootStore => ({
  paperworkEntryStore: rootStore.paperworkEntryStore,
  routerStore: rootStore.routerStore
}))
@observer
class PaperworkEntryPrint extends React.Component {
  constructor(props) {
    super(props);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.getPdfDocument = this.getPdfDocument.bind(this);
    this.handleBeforePrint = this.handleBeforePrint.bind(this);
  }

  // https://medium.com/@storrisi/how-to-show-a-pdf-stream-on-a-react-client-without-any-library-36220fee60cb
  async getPdfDocument() {
    const { paperworkEntryStore } = this.props;
    const { selectedForPrint } = this.props.paperworkEntryStore;

    var newWindow = window.open();
    var file = await paperworkEntryStore.getPdfDocument(selectedForPrint);

    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    newWindow.location = fileURL;
  }

  async componentDidMount() {
    await this.refreshData();
  }

  async handleRefresh() {
    await this.refreshData();
  }

  async refreshData() {
    const { paperworkEntryStore } = this.props;
    const { selectedForPrint } = this.props.paperworkEntryStore;

    await paperworkEntryStore.getPaperworkPrintData(selectedForPrint[0]);
  }

 async handleBeforePrint() {
    const { paperworkEntryStore } = this.props;
    const {  selectedForPrint } = this.props.paperworkEntryStore;
    await paperworkEntryStore.createPaperworkEntryPrintLog(selectedForPrint);
  }

  render() {
    const { loading, error, paperworkEntriesForPrint, selectedForPrint } = this.props.paperworkEntryStore;
    const { routerStore, paperworkEntryStore } = this.props;
    const goBack = () => {
      paperworkEntryStore.setDontClearFlag(true);
      routerStore.replace('/paperworks');
  }

    if (loading) {
      return <Loader />;
    }

    if (selectedForPrint.length == 0) {
      return <ErrorMessage message={"Please select entries for print."} />
    }

    if (paperworkEntriesForPrint) {
      return (
        <div className="container container--med">
          <div className="clear spc--bottom--med">
            <h3 className="pull type--medium">Paperwork Print Preview</h3>
            <div className="push">
              <button className="btn btn--med btn--primary spc--left--tny" onClick={this.getPdfDocument}>
                PDF
              </button>
              <ReactToPrint
                trigger={() => <a href="#" className="btn btn--med btn--primary spc--left--tny">Print</a>}
                content={() => this.componentRef}
                onBeforePrint={this.handleBeforePrint} />
              <button className="btn btn--med btn--primary spc--left--tny" onClick={goBack}>
                Back
              </button>
            </div>
          </div>
          <div className="spc--bottom--med">
            <PaperworkEntryPrintTemplate ref={el => (this.componentRef = el)} paperworkEntries={paperworkEntriesForPrint}></PaperworkEntryPrintTemplate>
          </div>      
        </div>
      );
    }

    return  <ErrorMessage message={error} />
  }
}

export { PaperworkEntryPrint };


// WEBPACK FOOTER //
// ./src/pages/PaperworkEntryPrint.js